module.exports = __webpack_public_path__ + "img/oval-green.cea949d2.svg";